import React from "react";

const Hero = () => (
  <section className="about-hero" aria-labelledby="about-hero-title">
    <div className="hero-pattern" aria-hidden="true">
      <svg
        width="100%"
        height="100%"
        preserveAspectRatio="xMidYMid slice"
        xmlns="http://www.w3.org/2000/svg"
      >
        <svg x="8%" y="20%" overflow="visible">
          <use
            xlinkHref="#about-blob-1"
            fill="#FFA5BC"
            transform="scale(2.4)"
            opacity="0.16"
          />
        </svg>
        <svg x="82%" y="78%" overflow="visible">
          <use
            xlinkHref="#about-blob-2"
            fill="#B798F2"
            transform="scale(3.0)"
            opacity="0.15"
          />
        </svg>
        <svg x="48%" y="-12%" overflow="visible">
          <use
            xlinkHref="#about-blob-3"
            fill="#E8EBFF"
            transform="scale(2.0)"
            opacity="0.5"
          />
        </svg>
        <svg x="62%" y="62%" overflow="visible">
          <use
            xlinkHref="#about-blob-1"
            fill="#F3EC7A"
            transform="scale(1.4)"
            opacity="0.32"
          />
        </svg>
      </svg>
    </div>
    <div className="wrap">
      <span className="eyebrow">About us - Est. 2016</span>
      <h1 className="hero-title" id="about-hero-title">
        Entertain <em>your</em> brain.
      </h1>
      <p className="hero-sub">
        We help you become the smartest, most curious, hardest-to-replace
        version of yourself by making learning the best part of your week.
      </p>
    </div>
  </section>
);

export default Hero;
